// src/components/InstallApp/styles.ts
import styled from 'styled-components';

export const Background = styled.div`
width: 100%;
height: 100%;
position: fixed;
top: 0;
left: 0;
z-index: 100;
background-color:rgba(63, 64, 65, 0.63);

`;

export const Banner = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  max-width: 90%;
  width: 400px;
  background: var(--bg-color-content);
  color: var(--text-main);
  padding: 15px 20px;
  font-size: 16px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 15px;
  box-shadow: var(--shadow);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;

  strong {
    font-weight: bold;
  }

  button.install {
    margin-top: 10px;
    background: var(--orange);
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 15px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background: var(--button-hover-bg-color);
    }
  }

  button.close {
    position: absolute;
    right: 5px;
    top: 5px;
    background: transparent;
    border: none;
    font-size: 30px;
    cursor: pointer;
    color: var(--text-secondary);
    transition: color 0.3s ease;

    &:hover {
      opacity: 0.7;
    }
  }
`;
